module.exports = __webpack_public_path__ + "img/qianming.a5d54822.png";